import React from 'react'
import { useTranslation } from 'react-i18next'

interface StepIndicatorProps {
  currentStep: number
  totalSteps: number
}

export const StepIndicator: React.FC<StepIndicatorProps> = ({ currentStep, totalSteps }) => {
  const { t } = useTranslation('pub', {
      keyPrefix: 'PublicRoutes.signUp',
    })

  return (
    <div className="step-indicator">
      <div className="step-text">
        {t("step", "step")} {currentStep} {t("of", "of")} {totalSteps}
      </div>
    </div>
  )
}
